<template>
  <div class="invoice-view">
    <v-card flat v-if="isLoading">
      <v-card-text>
        <v-progress-linear :indeterminate="true"></v-progress-linear>
      </v-card-text>
    </v-card>
    <div v-else>
      <v-card flat>
        <ReportViewBar v-if="items" :title="`Student Fee Subscription Discrepancy`" />
        
        <v-container fluid>
          <table class="center">
            <tbody class="report-container">
              <v-card-text class="pt-0">
                <v-data-table 
                  dense 
                  :headers="headers" 
                  :items="items" 
                  :itemsPerPage="-1" 
                  hide-default-footer
                  class="elevation-1"
                >
                  <template v-slot:item.CustomerName="{ item }">
                    <div class="font-weight-bold" @click="viewCustomerProfile(item.CustomerId)" style="cursor: pointer; color: #1976D2;">
                      {{ item.CustomerName }}
                    </div>
                  </template>

                  <template v-slot:item.students="{ item }">
                    <div>
                      <v-chip x-small color="info" outlined class="mr-1">{{ item.studentCount }} Students</v-chip>
                      <span class="caption grey--text text--darken-2">{{ item.studentNames }}</span>
                    </div>
                  </template>

                  <template v-slot:item.targetFee="{ item }">
                    <span class="font-weight-medium">{{ item.targetFee | currency }}</span>
                  </template>

                  <template v-slot:item.billedFee="{ item }">
                    <span :class="{'orange--text font-weight-bold': item.billedFee < item.targetFee}">
                      {{ item.billedFee | currency }}
                    </span>
                  </template>

                  <template v-slot:item.gap="{ item }">
                    <span class="red--text font-weight-bold">
                      {{ (item.targetFee - item.billedFee) | currency }}
                    </span>
                  </template>

                  <template v-slot:body.append v-if="items.length > 0">
                    <tr class="grey lighten-4 font-weight-bold">
                      <td colspan="2" class="text-right">TOTAL MONTHLY GAP:</td>
                      <td>{{ totalExpected | currency }}</td>
                      <td>{{ totalBilled | currency }}</td>
                      <td class="red--text">{{ totalGap | currency }}</td>
                    </tr>
                  </template>
                </v-data-table>
              </v-card-text>
            </tbody>
          </table>
        </v-container>
      </v-card>
    </div>
  </div>
</template>

<script>
import ReportViewBar from "@/components/ReportViewBar";
import reportService from "@/modules/ReportView/service";
import { mapActions } from "vuex";

export default {
  components: { ReportViewBar },
  data() {
    return {
      isLoading: true,
      items: [],
      headers: [
        { text: "PARENT NAME", value: "CustomerName", align: "left" },
        { text: "STUDENTS", value: "students", align: "left", sortable: false },
        { text: "EXPECTED MONTHLY", value: "targetFee", align: "right" },
        { text: "CURRENTLY BILLED", value: "billedFee", align: "right" },
        { text: "MONTHLY GAP", value: "gap", align: "right" },
      ],
    };
  },
  computed: {
    totalExpected() {
      return this.items.reduce((acc, item) => acc + parseFloat(item.targetFee || 0), 0);
    },
    totalBilled() {
      return this.items.reduce((acc, item) => acc + parseFloat(item.billedFee || 0), 0);
    },
    totalGap() {
      return this.totalExpected - this.totalBilled;
    }
  },
  created() {
    this.loadData();
    document.title = "Report - Subscription Discrepancy";
  },
  methods: {
    ...mapActions("global", ["initUser"]),
    loadData() {
      this.isLoading = true;
      reportService.getSubscriptionGap()
        .then((response) => {
          this.items = response.data || [];
          this.isLoading = false;
        })
        .catch(err => {
          console.error(err);
          this.isLoading = false;
        });
    },
    viewCustomerProfile(id) {
      window.open(`/parents/${id}/profile`, '_blank');
    },
    exportExcel() {
      // In a real implementation, this would trigger a CSV download or use a library
      // For now, we'll use the browser print function as a fallback or just inform the user
      window.print();
    }
  }
};
</script>

<style scoped>
@media print {
  .no-print {
    display: none !important;
  }
  .invoice-view {
    padding: 0 !important;
  }
}
.center {
  width: 100%;
  background-color: white;
}
</style>
